import { useState } from "react"
import _ from "lodash"

const testData = {
  "rp.RepresentmentTransactionInfo.Wallet": "PayPal"
}



export default function useRulesChecker() {

  const examineRules = (rules: any, renderPkg: any) => {
    let result:any[] = []; 
    let compareValue; 
    let modrules:any[] = [];

    const modifiedRules = rules.map( (rule:any) => ({
      ...rule,
      actions: rule.actions.map( (action:any) => {
        if( action.action === "replace" && action.replaceWith ){
          return { 
            ...action, 
            replaceWith: action.replaceWith, 
            // replaceWith: _.get(renderPkg.clientdata, `${action.replaceWith}`, null), 
            replaceLabel: action.replaceLabel || "" 
          }
        } else {
          return action
        }
      })
    }))


    // rules.forEach( (rule:any) => {
    //   rule.actions.forEach( (action:any) => {
    //     if( action.action === "replace" && action.replaceWith ){
    //       modrules.push({
    //         ...rule,
    //         action: {
    //           ...action,
    //           refstr: action.refstr,
    //           replaceWith: _.get(renderPkg.clientdata, `${action.replaceWith}`, null),
    //           replaceLabel: action.replaceLabel || ""
    //         }
    //       })
    //     } else {
    //       modrules.push({
    //         ...rule,
    //         action: {
    //           ...action,
    //           refstr: action.refstr,
    //           replaceWith: null, // no replacement value
    //           replaceLabel: action.replaceLabel || ""
    //         }
    //       })
    //     }  
    //   })
    // })

    modifiedRules.forEach( (condition:any) => {
      if( condition.config.lookup ){
        compareValue = _.get(renderPkg, condition.config.lookup, null); // get the value from renderPkg based on the lookup path
        if( testData && testData[condition.config.lookup] ){
          compareValue = testData[condition.config.lookup]; // use test data if available
        }
        if( condition.config.operator === "eq" && compareValue === condition.config.value ) {
          console.log("condition match")
          result = [...result, ...condition.actions]
        } else if( condition.config.operator === "neq" && compareValue !== condition.config.value ) {
          console.log("condition match")
          return condition.actions
        } else if( condition.config.operator === "contains" && compareValue && compareValue.includes(condition.config.value) ) {
          console.log("condition match")
          return condition.actions
        } else if ( condition.config.operator === "notcontains" && compareValue && !compareValue.includes(condition.config.value) ) {
          console.log("condition match")
          return condition.actions
        } else if ( condition.config.operator === "exists" && compareValue !== null && compareValue !== undefined ) {
          console.log("condition match")
          return condition.actions
        } else if ( condition.config.operator === "notexists" && (compareValue === null || compareValue === undefined) ) {
          console.log("condition match")
          return condition.actions
        }
      }
    })
    // console.log("replacementData", replacementData)
    return result
  }

  const checkForSubstitute = (type:string, value:any, refstr:string, rulesCheck:any[]) => {
    const foundRule = rulesCheck.find( (rule:any) => rule.target === refstr && rule.action === "replace" )
    if( foundRule && foundRule.replaceWith ){
      return (type === "label") ? foundRule.replaceLabel : foundRule.replaceWith
    } else {
      return value
    }
  }


  const check = (location:string, renderPkg:any) => {

    const { subdomain, rpid } = renderPkg.clientdata;

    const locationMatches = renderPkg.rulesdata.filter( (rule:any) => rule.location === location )
    if( !locationMatches || !Object.keys(locationMatches).length ) return [] // no rules found, return true
   
    const getSubdomainMatches = locationMatches.filter( (rule:any) => rule.subdomain === "-any-" || rule.subdomain === subdomain )
    if( !getSubdomainMatches || !getSubdomainMatches.length ) return [] // no subdomain matches found, return true 

    const getRpidMatches = getSubdomainMatches.filter( (rule:any) => rule.rpid === "-any-" || rule.rpid === rpid )
    if( !getRpidMatches || !getRpidMatches.length ) return [] // no rpid matches found, return true

    const rules = getRpidMatches.map( (rule:any) => rule.rule ) // extract the rules from the matched rules

    const exam = examineRules(rules, renderPkg) // process the rules with the render package
    console.log("exam", exam)
    return exam; // return the result of the examination
  }

  const hideTheseItems = (rulesCheck:any[]) => rulesCheck.filter( (item:any) => item.action === "hide" ).map( (item:any) => item.target )

  return {
    check,
    checkForSubstitute,
    hideTheseItems
  }
}